import React from "react";
import villa1 from "../assets/villa1.jpg";
import planBig from "../assets/plan-big.png"; // floorplan image

const BigVilla = () => {
  return (
    <div className="villa-detail">
      <header
        className="villa-hero"
        style={{
          backgroundImage: `url(${villa1})`,
        }}
      >
        <div className="overlay">
          <h1>Big Villa</h1>
          <p>Luxury redefined in 399 m²</p>
        </div>
      </header>

      <section className="villa-info">
        <h2>About the Villa</h2>
        <p>
          The Big Villa offers a spacious 399 m² layout across two floors.
          Featuring 4 bedrooms, 3 bathrooms, 2 wardrobes, a private swimming
          pool, modern garage, and barbecue space, it is designed for comfort
          and luxury.
        </p>
      </section>

      <section className="villa-plan">
        <h2>Villa Plan</h2>
        <img src={planBig} alt="Big Villa Floorplan" />
      </section>

      <section className="villa-amenities">
        <h2>Included Amenities</h2>
        <ul>
          <li>Private swimming pool</li>
          <li>Smart home system</li>
          <li>Solar panel integration</li>
          <li>VR-ready interior design</li>
          <li>Landscaped private garden</li>
        </ul>
      </section>

      <section className="villa-pricing">
        <h2>Pricing</h2>
        <p className="price">$750,000 – $1,000,000</p>
        <p>Flexible payment plans available upon request.</p>
      </section>
    </div>
  );
};

export default BigVilla;
